import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { DonationForm } from '@feathr/blackbox';
import { UniversalSelect } from '@feathr/components';
import type { ListResponse } from '@feathr/rachis';

interface ISelectOption {
  id: string;
  name: string;
}

interface IProps {
  donationForms: ListResponse<DonationForm>;
  onSelectForms: (values: ISelectOption[]) => void;
  selectedForms: ISelectOption[];
}

function FormsSelect({
  donationForms,
  onSelectForms,
  selectedForms,
}: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  const formOptions: ISelectOption[] = donationForms.models.map((form: DonationForm) => ({
    id: form.id,
    name: form.name,
  }));

  return (
    <UniversalSelect<ISelectOption>
      isLoading={donationForms.isPending}
      isMulti={true}
      label={t('Donation forms')}
      name={'forms'}
      onSelectMulti={onSelectForms}
      options={formOptions}
      placeholder={t('All donation forms')}
      value={selectedForms}
    />
  );
}

export default FormsSelect;
